import React from 'react'
import './Section1.css'

const Section1 = () => {
  return (
    <div className="section1-container" id='NEW'>
        <video  src="https://res.cloudinary.com/facemetaclone/video/upload/v1662234010/pexels-cottonbro-8443734_ykpfpu.mp4" type='video/mp4/' className='bg-video' autoPlay loop muted>
        </video>
    </div>
  )
}

export default Section1